export default __webpack_public_path__ + "static/media/check_secondary.16501621.svg";